var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0581\\u0561\\u056C\\u0581\\u0582\\u056C\\u0561\\u057F\\u0585\\u0580\\u2014\\u056B\\u0581",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.599,2 C18.8649583,2 19.9095816,2.9909566 19.9944357,4.23531583 L20,4.399 L20,19.6 C20,20.8745833 19.008125,21.9103819 17.7628091,21.9944857 L17.599,22 L5.399,22 C4.12441667,22 3.08953646,21.017309 3.00550926,19.7648372 L3,19.6 L3,4.399 C3,3.134 3.98177257,2.09033507 5.23416782,2.00555917 L5.399,2 L17.599,2 Z M17.899,10.02 L5.099,10.02 L5.099,19.6 C5.099,19.7457143 5.1945102,19.8613061 5.32885423,19.8913586 L5.399,19.899 L17.599,19.899 C17.7361429,19.899 17.8585918,19.8042245 17.8907784,19.6700904 L17.899,19.6 L17.899,10.02 Z M8.5393,16.0507 L8.5393,18.1997 L6.3993,18.1997 L6.3993,16.0507 L8.5393,16.0507 Z M12.4793,16.0507 L12.4793,18.1997 L10.3393,18.1997 L10.3393,16.0507 L12.4793,16.0507 Z M16.5093,11.3897 L16.5093,18.1997 L14.3593,18.1997 L14.3593,11.3897 L16.5093,11.3897 Z M12.4793,11.6497 L12.4793,13.7997 L10.3393,13.7997 L10.3393,11.6497 L12.4793,11.6497 Z M8.5393,11.6497 L8.5393,13.7997 L6.3993,13.7997 L6.3993,11.6497 L8.5393,11.6497 Z M17.599,4.1 L5.399,4.1 C5.25328571,4.1 5.13695918,4.20212245 5.10669679,4.33205831 L5.099,4.399 L5.099,7.92 L17.899,7.92 L17.899,4.399 C17.899,4.26185714 17.7961429,4.14014286 17.6659971,4.10816618 L17.599,4.1 Z",
    id: "Shape",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIc);
export default __webpack_public_path__ + "static/media/calculator_ic.71f93c6362476b158aceb1c50017ad54.svg";
export { ForwardRef as ReactComponent };